<template>
  <div class="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
    <button type="button" class="-m-2.5 p-2.5 text-gray-700 lg:hidden" @click="$emit('toggle-sidebar')">
      <span class="sr-only">Open sidebar</span>
      <Bars3Icon class="h-6 w-6" />
    </button>
    
    <!-- Separator -->
    <div class="h-6 w-px bg-gray-200 lg:hidden" />
    
    <div class="flex flex-1 gap-x-4 self-stretch lg:gap-x-6 justify-end">
      <div class="flex items-center gap-x-4 lg:gap-x-6">
        <!-- Profile dropdown -->
        <div class="relative">
          <button 
            @click="profileOpen = !profileOpen"
            class="-m-1.5 flex items-center p-1.5"
          >
            <span class="sr-only">Open user menu</span>
            <div class="h-8 w-8 rounded-full bg-orange-100 flex items-center justify-center text-orange-600 font-semibold">
              {{ userInitials }}
            </div>
            <span class="hidden lg:flex lg:items-center ml-4">
              <span class="text-sm font-semibold leading-6 text-gray-900">
                {{ authStore.user?.full_name }}
              </span>
              <ChevronDownIcon class="ml-2 h-5 w-5 text-gray-400" :class="{ 'rotate-180': profileOpen }" />
            </span>
          </button>
          
          <div v-if="profileOpen" class="absolute right-0 z-10 mt-2.5 w-32 bg-white rounded-md py-2 shadow-lg ring-1 ring-gray-900/5">
            <button
              @click="logout"
              class="block w-full text-left px-3 py-1 text-sm leading-6 text-gray-900 hover:bg-gray-50"
            >
              Sair
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { Bars3Icon, ChevronDownIcon } from '@heroicons/vue/24/outline'
import { useAuthStore } from '@/stores'

const router = useRouter()
const authStore = useAuthStore()

const profileOpen = ref(false)

defineEmits<{
  'toggle-sidebar': []
}>()

const userInitials = computed(() => {
  const name = authStore.user?.full_name || ''
  return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
})

const logout = () => {
  authStore.logout()
  router.push('/login')
}
</script>
